import React, { useEffect, useState } from "react";
import CustomInput from "../../../../components/common/CustomInput/CustomInput";
import CustomFileUpload from "../../../../components/common/CustomFileUpload/CustomFileUpload";
import BodyHeader from "../../../../components/common/CommonBodyHeader";
import CustomDatePicker from "../../../../components/common/CustomDatePicker/CustomDatePicker";
import CustomDropdown from "../../../../components/common/CustomDropdown/CustomDropdown";
import CustomTextArea from "../../../../components/common/CustomTextArea/CustomTextArea";

import { useDispatch, useSelector } from "react-redux";
import {
   fetchAllLaneAsync,
   fetchAllLocationAsync,
   fetchLaneMasterDetailsAsync,
   fetchSingleVendorMasterAsync,
   updateVendorAsync,
} from "../../../../redux/features/vendorMaster";

import { useParams } from "react-router-dom";
import EditContactPerson from "./edit-contact-person";
import EditLaneDetails from "./edit-lane-details";
import { backdropLoadingAction } from "../../../../redux/features/helperSlice";
import toast from "react-hot-toast";
import { useFormik } from "formik";
import * as yup from "yup";
import { editfileSchema } from "../../../../helpers/fileValidationRules";
import AgreementDetails from "./agreement-details";

const validationSchema = yup.object().shape({
   id: yup.string(),
   vendor: yup.object().shape({
      name: yup
         .string()
         .required("Vendor name is required.")
         .matches(/^[a-zA-Z][a-zA-Z-' ]{1,50}[a-zA-Z]$/, "Invalid name!"),
      accountNumber: yup
         .string()
         .required("Account number is required.")
         .matches(/^\d{9,18}$/, "Invalid account number!"),
      bankName: yup
         .string()
         .required("BankName is required.")
         .matches(/^[a-zA-Z][a-zA-Z-' ]{1,50}[a-zA-Z]$/, "Invalid bank name!"),
      ifscCode: yup.string().required("IFSC code is required."),
      accountHolderName: yup
         .string()
         .required("Account holder name is required.")
         .matches(/^[a-zA-Z][a-zA-Z-' ]{1,50}[a-zA-Z]$/, "Invalid account holder name!"),
      bankDocument: editfileSchema,
      gstNumber: yup
         .string()
         .matches(
            /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
            "Invalid gst number!"
         ),
      gstDocument: editfileSchema,
      location: yup.string().required("Location is required."),
      address: yup.string().required("Address is required."),
   }),
});

export default function VendorMasterEdit() {
   const [isChildUpdated, setIsChildUpdated] = useState(false);

   const vendorMaster = useSelector((state) => state.vendorMaster);
   const singleVendorMaster = vendorMaster.singleVendorMaster;
   // For lane dropdown

   // For location dropdown
   const locationData = vendorMaster.locationData.map((item) => ({
      label: item?.name,
      value: item?.id,
   }));

   const dispatch = useDispatch();
   const { id: vendorId } = useParams();

   // If child updated then fetch data again
   useEffect(() => {
      if (isChildUpdated) {
         // dispatch(backdropLoadingAction(true));
         dispatch(
            fetchSingleVendorMasterAsync({
               id: vendorId,
               done: () => {
                  // dispatch(backdropLoadingAction(false));
               },
               err: (error) => {
                  // dispatch(backdropLoadingAction(false));
                  toast.error(error);
               },
            })
         );
         setIsChildUpdated(false);
      }
   }, [isChildUpdated]);

   useEffect(() => {
      dispatch(backdropLoadingAction(true));
      dispatch(
         fetchSingleVendorMasterAsync({
            id: vendorId,
            done: () => {
               dispatch(backdropLoadingAction(false));
            },
            err: (error) => {
               dispatch(backdropLoadingAction(false));
               toast.error(error);
            },
         })
      );
      dispatch(fetchAllLocationAsync({}));
      dispatch(fetchAllLaneAsync({}));
      dispatch(fetchLaneMasterDetailsAsync(vendorId));
   }, []);

   // Set initial values from api data
   useEffect(() => {
      if (singleVendorMaster) {
         // dispatch(backdropLoadingAction(true));
         setValues({
            id: singleVendorMaster?.id,
            vendor: {
               name: singleVendorMaster?.name,
               accountNumber: singleVendorMaster?.account_number,
               bankName: singleVendorMaster?.bank_name,
               ifscCode: singleVendorMaster?.ifsc_code,
               accountHolderName: singleVendorMaster?.account_holder_name,
               bankDocument: singleVendorMaster?.bank_document,
               gstNumber: singleVendorMaster?.gst_number,
               gstDocument: singleVendorMaster?.gst_document,
               location: singleVendorMaster?.location_master?.id,
               address: singleVendorMaster?.address,
            },
            agreement: {
               startDate: singleVendorMaster?.agreement_start_date,
               endDate: singleVendorMaster?.agreement_end_date,
               document: singleVendorMaster?.agreement_document,
            },
         });
         // dispatch(backdropLoadingAction(false));
      }
   }, [singleVendorMaster]);

   const formik = useFormik({
      initialValues: {
         id: "",
         vendor: {
            name: "",
            accountNumber: "",
            bankName: "",
            ifscCode: "",
            accountHolderName: "",
            bankDocument: "",
            gstNumber: "",
            gstDocument: "",
            location: "",
            address: "",
         },
      },
      validationSchema: validationSchema,
      onSubmit: (formData) => {
         dispatch(backdropLoadingAction(true));
         console.log({ iiiiiii: formData.vendor.gstNumber });

         const data = {
            id: formData.id,
            name: formData.vendor.name,
            account_number: formData.vendor.accountNumber,
            bank_name: formData.vendor.bankName,
            ifsc_code: formData.vendor.ifscCode,
            account_holder_name: formData.vendor.accountHolderName,
            gst_document: formData.vendor.gstDocument,
            location_master_id: formData.vendor.location,
            address: formData.vendor.address,

            _method: "PATCH",
            model_id: 7,
            action_id: 2,
         };

         if (formData.vendor.gstNumber) {
            data.gst_number = formData.vendor.gstNumber;
         }

         if (typeof data.bank_document === "string") {
            delete data.bank_document;
         }
         if (typeof data.gst_document === "string") {
            delete data.gst_document;
         }

         const newData = new FormData();
         Object.keys(data).forEach((key) => {
            newData.append(key, data[key]);
         });

         dispatch(
            updateVendorAsync({
               data: newData,
               done: () => {
                  dispatch(backdropLoadingAction(false));
                  toast.success("Updated successfully.");
               },
               err: (error) => {
                  dispatch(backdropLoadingAction(false));
                  toast.error(error);
               },
            })
         );
      },
   });

   const {
      setValues,
      errors,
      touched,
      values,
      getFieldProps,
      handleSubmit,
      setFieldValue,
      resetForm,
   } = formik;

   return (
      <div>
         <BodyHeader title="Edit Vendor Master" className="p-3 shadow-lg" />
         <div>
            <div className="row">
               <div className="col-lg-12">
                  <div className="card card-primary">
                     <div className="card-header">
                        <h3 className="card-title">Vendor Details</h3>
                     </div>
                     <div className="card-body">
                        <div className="row">
                           <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                              <CustomInput
                                 require={true}
                                 label="Vendor Name"
                                 id="vendorName"
                                 placeholder="Enter Vendor Name"
                                 {...getFieldProps("vendor.name")}
                                 errors={touched?.vendor?.name && errors?.vendor?.name}
                                 message={errors?.vendor?.name}
                              />
                           </div>
                           <div className="col-lg-4">
                              <CustomInput
                                 require
                                 label="Account Number"
                                 id="AccountNumber"
                                 placeholder="Enter Account Number"
                                 {...getFieldProps("vendor.accountNumber")}
                                 errors={
                                    touched?.vendor?.accountNumber &&
                                    errors?.vendor?.accountNumber
                                 }
                                 message={errors?.vendor?.accountNumber}
                              />
                           </div>
                           <div className="col-lg-4">
                              <CustomInput
                                 require
                                 label="Bank name"
                                 id="bankName"
                                 placeholder="Enter Bank Name"
                                 {...getFieldProps("vendor.bankName")}
                                 errors={
                                    touched?.vendor?.bankName && errors?.vendor?.bankName
                                 }
                                 message={errors?.vendor?.bankName}
                              />
                           </div>
                           <div className="col-lg-4">
                              <CustomInput
                                 require
                                 label="IFSC Code"
                                 id="ifscCode"
                                 placeholder="Enter IFSC Code"
                                 {...getFieldProps("vendor.ifscCode")}
                                 errors={
                                    touched?.vendor?.ifscCode && errors?.vendor?.ifscCode
                                 }
                                 message={errors?.vendor?.ifscCode}
                              />
                           </div>

                           <div className="col-lg-4">
                              <CustomInput
                                 require
                                 label="Account Holder Name"
                                 id="accountHolderName"
                                 placeholder="Enter Account Holder name"
                                 {...getFieldProps("vendor.accountHolderName")}
                                 errors={
                                    touched?.vendor?.accountHolderName &&
                                    errors?.vendor?.accountHolderName
                                 }
                                 message={errors?.vendor?.accountHolderName}
                              />
                           </div>
                           <div className="col-lg-4">
                              <CustomFileUpload
                                 require={true}
                                 label="Bank Document"
                                 id="bankDetails"
                                 {...getFieldProps("vendor.bankDocument")}
                                 onChange={(e) => {
                                    setFieldValue(
                                       "vendor.bankDocument",
                                       e.target.files[0]
                                    );
                                 }}
                                 errors={
                                    touched?.vendor?.bankDocument &&
                                    errors?.vendor?.bankDocument
                                 }
                                 message={errors?.vendor?.bankDocument}
                              />
                           </div>
                           <div className="col-lg-4">
                              <CustomInput
                                 label="GST Number"
                                 id="gstNumber"
                                 placeholder="Enter GST Number"
                                 {...getFieldProps("vendor.gstNumber")}
                                 errors={
                                    touched?.vendor?.gstNumber &&
                                    errors?.vendor?.gstNumber
                                 }
                                 message={errors?.vendor?.gstNumber}
                              />
                           </div>
                           <div className="col-lg-4">
                              <CustomFileUpload
                                 label="GST Document"
                                 id="gst"
                                 {...getFieldProps("vendor.gstDocument")}
                                 onChange={(e) => {
                                    setFieldValue(
                                       "vendor.gstDocument",
                                       e.target.files[0]
                                    );
                                 }}
                                 errors={
                                    touched.vendor?.gstDocument &&
                                    errors.vendor?.gstDocument
                                 }
                                 message={errors.vendor?.gstDocument}
                              />
                           </div>

                           <div className="col-lg-4">
                              <CustomDropdown
                                 label="location"
                                 require={true}
                                 values={locationData?.filter(
                                    (item) => item.value === values.vendor.location
                                 )}
                                 optionData={locationData}
                                 onChange={(values) => {
                                    setFieldValue("vendor.location", values[0].value);
                                 }}
                                 errors={
                                    touched?.vendor?.location && errors?.vendor?.location
                                 }
                                 message={errors?.vendor?.location}
                              />
                           </div>
                           <div className="col-lg-12">
                              <CustomTextArea
                                 require={true}
                                 label="Address"
                                 id="VendorLocation"
                                 {...getFieldProps("vendor.address")}
                                 errors={
                                    touched?.vendor?.address && errors?.vendor?.address
                                 }
                                 message={errors?.vendor?.address}
                              />
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>

            <div className="mb-3 text-right">
               <button
                  className="btn btn-primary px-4 py-3"
                  type="submit"
                  onClick={handleSubmit}
               >
                  <h6 className="mb-0 text-uppercase">Update</h6>
               </button>
            </div>

            <div className="row">
               <div className="col-lg-12 mt-5">
                  <AgreementDetails
                     id={vendorId}
                     data={singleVendorMaster?.vendor_agreement}
                  />
                  {/* <div className="card-body row">
                        <div className="col-lg-4">
                           <CustomDatePicker
                              require={true}
                              label="Agreement Start Date"
                              placeholder="Enter Agreement Start Date"
                              {...getFieldProps("agreement.startDate")}
                              errors={
                                 touched.agreement?.startDate &&
                                 errors.agreement?.startDate
                              }
                              message={errors.agreement?.startDate}
                           />
                        </div>
                        <div className="col-lg-4">
                           <CustomDatePicker
                              require={true}
                              label="Agreement End Date"
                              placeholder="Enter Agreement End Date"
                              {...getFieldProps("agreement.endDate")}
                              errors={
                                 touched.agreement?.startDate && errors.agreement?.endDate
                              }
                              message={errors.agreement?.endDate}
                           />
                        </div>
                        <div className="col-lg-4">
                           <CustomFileUpload
                              require={true}
                              label="Agreement Document"
                              {...getFieldProps("agreement.document")}
                              onChange={(e) => {
                                 setFieldValue("agreement.document", e.target.files[0]);
                              }}
                              errors={
                                 touched.agreement?.document && errors.agreement?.document
                              }
                              message={errors.agreement?.document}
                           />
                        </div>
                     </div> */}
               </div>
            </div>
         </div>

         <div className="row mt-5">
            <div className="col-lg-12">
               <EditContactPerson
                  data={singleVendorMaster?.contact_personal_details}
                  vendorId={vendorId}
                  setIsChildUpdated={setIsChildUpdated}
               />
            </div>
         </div>

         <div className="row mt-5">
            <div className="col-lg-12">
               <EditLaneDetails
                  data={singleVendorMaster?.lane}
                  vendorId={vendorId}
                  setIsChildUpdated={setIsChildUpdated}
               />
            </div>
         </div>
      </div>
   );
}
